import { render } from "./AssignClaim.vue?vue&type=template&id=517d0a2e"
import script from "./AssignClaim.vue?vue&type=script&lang=js"
export * from "./AssignClaim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__